import React from 'react';
import type { HeaderState } from '../../reducers/header-reducer';
import AudiHeaderDealerContext from '../AudiHeaderDealerContext/AudiHeaderDealerContext';
import DealerSearch from '../AudiHeaderDealerContext/DealerSearch';
import AudiHeaderDealerContextAlpha from '../AudiHeaderDealerContext/AudiHeaderDealerContext_alpha';
import { getDealerSearchHashParam } from '../../utils/append-partner-id';

interface DealerComponentsProps {
  headerState: HeaderState;
  showDealerContext: boolean;
  headerNavigationItemsAmount: number;
  dealerSearch: boolean;
  isTierOneDomain: boolean;
  dealerSearchGeolocationEnabled: boolean;
  onClickDealerContext: () => void;
  onClickDealerSearchContext: () => void;
  isSmallView: boolean;
  autoConnectedUnsubscribed: boolean;
  geoError: any;
}

const DealerComponents: React.FC<DealerComponentsProps> = ({
  headerState,
  showDealerContext,
  headerNavigationItemsAmount,
  dealerSearch,
  isTierOneDomain,
  dealerSearchGeolocationEnabled,
  onClickDealerContext,
  onClickDealerSearchContext,
  isSmallView,
  autoConnectedUnsubscribed,
  geoError,
}) => {
  const isLegacy = Boolean(process.env.IS_LEGACY);
  const isDealerContextLegacy = showDealerContext && isTierOneDomain && isLegacy;
  const isDealerContextAlpha = showDealerContext && isTierOneDomain && !isLegacy;
  const isDealerSearchLegacyDesktop = dealerSearch && isTierOneDomain && isLegacy && !isSmallView;
  const isDealerSearchAlphaDesktop = dealerSearch && isTierOneDomain && !isLegacy && !isSmallView;

  // disable 'dealerSearchGeolocationEnabled' is user had already disconnected by checking sessionStorage DEALER_CONTEXT_AUTOCONNECT_UNSUBSCRIBE
  const gelocationEnabled =
    dealerSearchGeolocationEnabled && !autoConnectedUnsubscribed && !geoError;

  const showDealerSearch =
    gelocationEnabled ||
    headerState.activeItem.showDealerSearch ||
    getDealerSearchHashParam('consumerLocations');

  // Legacy DealerContext Desktop View
  if (isDealerContextLegacy) {
    return (
      <AudiHeaderDealerContext
        headerNavigationItemsAmount={headerNavigationItemsAmount}
        dealerSearch={dealerSearch}
        onClickDealerContext={onClickDealerContext}
        onClickDealerSearchContext={onClickDealerSearchContext}
        showDealerAdditionalData={headerState.activeItem.showDealer}
        showDealerSearch={showDealerSearch}
      />
    );
  }

  // Legacy DealerSearch Desktop View
  if (isDealerSearchLegacyDesktop) {
    return (
      <DealerSearch
        headerNavigationItemsAmount={headerNavigationItemsAmount}
        onClickDealerSearchContext={onClickDealerSearchContext}
        dealerSearchGeolocationEnabled={gelocationEnabled}
        showDealerSearch={gelocationEnabled || headerState.activeItem.showDealerSearch}
      />
    );
  }

  // Alpha DealerContext Desktop View
  if (isDealerContextAlpha) {
    return (
      <AudiHeaderDealerContextAlpha
        headerNavigationItemsAmount={headerNavigationItemsAmount}
        dealerSearch={dealerSearch}
        onClickDealerContext={onClickDealerContext}
        onClickDealerSearchContext={onClickDealerSearchContext}
        showDealerAdditionalData={headerState.activeItem.showDealer}
        isMobileView={isSmallView}
        showDealerSearch={showDealerSearch}
      />
    );
  }

  // Alpha DealerSearch Desktop View
  if (isDealerSearchAlphaDesktop) {
    return (
      <DealerSearch
        headerNavigationItemsAmount={headerNavigationItemsAmount}
        onClickDealerSearchContext={onClickDealerSearchContext}
        dealerSearchGeolocationEnabled={gelocationEnabled}
        showDealerSearch={gelocationEnabled || headerState.activeItem.showDealerSearch}
      />
    );
  }

  return null;
};

export default DealerComponents;
